export default __webpack_public_path__ + "static/media/solar.e03d8b2e.webp";